import * as React from 'react'
import styled from '@emotion/styled';
import { push as Menu } from 'react-burger-menu'
import {SlideDown} from 'react-slidedown'
import 'react-slidedown/lib/slidedown.css'
import Ripples from 'react-ripples'




import Headroom from 'react-headroom';
const menu_icon = require('../../../assets/images/menu_three.png')
const logo = require('../../../assets/images/V7_000_Logo.png')
const logoMenu = require('../../../assets/images/logo.png')




//import { heights, dimensions, colors } from '../styles/variables'
//import Container from './Container'
import {Link} from "gatsby";
import LocalizedLink from "../int/LocalizedLink";
import {navigate} from "@reach/router";
import Toggler from "../Toggler";
const StyledHeadroom = styled(Headroom)`

display:none;
z-index:999;
position:relative;
  @media screen and (max-width: 1250px) {
display:block;

   }
`





const A = styled.a`
display:block;

text-align:center;
position:relative;
z-index:999999;
transition:all ease .7s;
padding-top:0.4em;
padding-bottom:0.4em;
letter-spacing:1px;
text-decoration:none !important;


:hover{
color:black;
text-decoration:none !important;



}
`


const ABorder = styled.a`
display:block;
font-family: "Theano Didot", Regular;

text-align:center;
position:relative;
z-index:999999;
transition:all ease .7s;
padding-top:0.4em;
padding-bottom:0.4em;
letter-spacing:2px;


:hover{
color:black;
  letter-spacing: 0px;



}
`






var styles = {

  bmBurgerButton: {
    position: 'fixed',
    width: '36px',
    height: '30px',
    left: '36px',
    top: '36px',
  },
  bmBurgerBars: {
    background: '#373a47'
  },
  bmBurgerBarsHover: {
    background: '#a90000'
  },
  bmCrossButton: {
    height: '24px',
    width: '24px',
    right:'1em'
  },
  bmCross: {
    background:'lightgrey',

  },
  bmMenuWrap: {
    width:'305px',
    position: 'fixed',
    height: '100%',
    top:0,
    zIndex:99999999,
    overflowY: 'overlay'
  },
  bmMenu: {
    background: 'white',
    padding: '0 20px 0',
    fontSize: '1em',
    top:0,
    zIndex:99999999,
    minWidth:'300px !important'

  },
  bmMorphShape: {
    fill: 'white',
    zIndex:99999999

  },
  bmItemList: {
    padding: '8px',
    top:0
  },
  bmItem: {
    display:'flex',
    justifyContent:'center',
    alignItems:'center'



  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)',
    top:0,
    zIndex:99999999

  }
}

const Img = styled.div`
margin-top:1em;
margin-bottom: 1.2em;
width:210px;
.cls-1{fill:var(--textNormal);}
`

const ImgDiv =styled.div`
width:100%;
display:flex ;
justify-content:center;
align-items:center;


`

const StyledHeader = styled.header`
  height: 58px;
position:relative;
z-index:9999999;
  background-color: var(--bg);
  box-shadow: 0px 6px 5px rgba(0, 0, 0, 0.157);
  display:flex;
  align-items:center;



`






const MenuIcon = styled.div`
cursor:pointer;
width: 44px;
height:auto;
opacity:0.97;
padding-left:0.5rem;
;
.stripe-1{fill:var(--textNormal);}

`

const MenuDiv = styled.div`

cursor:pointer;
height:100%;
width:auto;
display:flex;
align-items:center;
position:absolute;
right:0;
z-index:99999999;
border-radius:2px;
padding-right:1.3rem;
padding-left:1rem;
border-right: 1px solid rgba(68,68,68,0);


transition:all .7s ease;

:hover{
background:rgba(68,68,68,.17);
border-right: 1px solid rgba(68,68,68,.1);
}

`
const LogoDiv = styled.div`
height:100%;
justify-content:center;
width:100%;
text-align:center;
position:absolute;


`
const Logo = styled.div`
 top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
cursor:pointer;
width: 37px;
position: absolute;
height:auto;
left:50%;
right:24px;
.polygon{fill:var(--textNormal);}

`



const CenterHelper = styled.span`
    display: inline-block;
    height: 100%;
    vertical-align: middle;
`

const StyledMenu = styled(Menu)`
font-family: "Theano Didot", Regular;
letter-spacing:2px;
z-index:9999999999;
background:var(--bg);
.flag-options{
width:200px !important;
right:-80px;
background:white !important;
opacity:1 !important;
}

.bm-menu{
background:var(--bg) !important;
}

`

const ArrowImg = styled.img`
width:5.5%;
position:absolute;
margin-top:7.5px;
margin-left:6px;
transition:all ease 1s;

`

const ArrowImg_2 = styled.img`
margin-top:3px;
width:10%;
transition:all ease 1s;


`

const StyledLink = styled(Link)`
color:var(--textLink);
opacity:1;
width: 100%;
text-decoration:none !important;

:hover{
text-decoration:none !important;
}

`

const StyledLink_2 = styled(Link)`
color:var(--textLink);
opacity:1;
width: 100%;


`
const StyledLink_3 = styled.a`
color:var(--textLink);
opacity:1;
width: 100%;


`

const BorderTopBottom = styled.div`
border-top:1px solid rgba(68,68,68,.2);
border-bottom:1px solid rgba(68,68,68,.2);
width:100%;


`

const BorderBottom = styled(Ripples)`
border-bottom:1px solid rgba(68,68,68,.2);
width:100%;

`

const ToggleDiv = styled(Ripples)`
display:flex;
justify-content:center;
align-items:center;
width:100%;

`

const HeadroomDiv = styled.div`
background:var(--bg);

`

function onSelectFlag(countryCode){
  let c = countryCode.toLowerCase();
  console.log(c + ' test c variable');
  if (c === 'de')
    navigate(
      "/",
      { replace: true }      )
  if (c === 'gb')
    navigate('/en',  { replace: true });
}


export class BurgerMenu extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false,
      roomsClosed:true,
      optionsClosed:true,
      rotation: 0,
      rotation_2: 0

    }
    this.rotate = this.rotate.bind(this);
    this.rotate_2 = this.rotate_2.bind(this);

  }

  rotate(){
    let newRotation = this.state.rotation;
    if(newRotation === 180){
      newRotation -= 180;
    }
else
    if(newRotation === 0){
      newRotation += 180;
    }
    this.setState({
      rotation: newRotation,
    })
  }

  rotate_2(){
    let newRotation = this.state.rotation_2;
    if(newRotation === 0){
      newRotation += 270;
    }
    else
    if(newRotation === 270){
      newRotation -= 270;
    }
    this.setState({
      rotation_2: newRotation,
    })
  }

  // This keeps your state in sync with the opening/closing of the menu
  // via the default means, e.g. clicking the X, pressing the ESC key etc.
  handleStateChange (state) {
    this.setState({menuOpen: state.isOpen})
  }

  // This can be used to close the menu, e.g. when a user clicks a menu item
  closeMenu () {
    this.setState({menuOpen: false})
  }

  // This can be used to toggle the menu, e.g. when using a custom icon
  // Tip: You probably want to hide either/both default icons if using a custom icon
  // See https://github.com/negomi/react-burger-menu#custom-icons
  toggleMenu () {
    this.setState({menuOpen: !this.state.menuOpen})
  }

  // This can be used to toggle the menu, e.g. when using a custom icon
  // Tip: You probably want to hide either/both default icons if using a custom icon
  // See https://github.com/negomi/react-burger-menu#custom-icons
  toggleRooms () {
    this.setState({roomsClosed: !this.state.roomsClosed});
    this.rotate();
  }

  toggleOptions () {
    this.setState({optionsClosed: !this.state.optionsClosed});
    this.rotate_2();

  }


  render () {
    return (
      <HeadroomDiv>
        <StyledHeadroom>
          <StyledHeader>
            <MenuDiv onClick={() => this.toggleMenu()}>
              <MenuIcon>
                <svg id="menu" data-name="menu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85.15 26.32">
                  <defs>
                  </defs>
                  <title>menu</title>
                  <rect className="stripe-1" width="85.15" height="5.4"/>
                  <rect className="stripe-1" y="10.46" width="85.15" height="5.4"/>
                  <rect className="stripe-1" y="20.92" width="85.15" height="5.4"/>
                </svg>
              </MenuIcon>
            </MenuDiv>

              <Logo>
                <svg id="logo-small" data-name="logo-small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.03 78.75">
                  <title>v7-logo</title>
                  <polygon className="polygon" points="76.03 0 71.27 0 38.02 68.91 4.76 0 0 0 38 78.75 38.03 78.75 76.03 0"/>
                  <polygon className="polygon" points="61.6 0 38.06 48.79 14.43 0 9.67 0 38.02 58.73 66.36 0 61.6 0"/>
                  <polygon className="polygon" points="21.42 3.9 50.43 3.9 35.79 34.24 38.17 39.17 57.07 0 19.64 0 21.42 3.9"/>
                </svg>

              </Logo>




          </StyledHeader>
        </StyledHeadroom>
        <StyledMenu
          right
          disableAutoFocus
          customBurgerIcon={ false }
          isOpen={this.state.menuOpen}
          onStateChange={(state) => this.handleStateChange(state)}
          styles={styles}
          pageWrapId={ "page-wrap" }
        >
          <ImgDiv>
          <Img onClick={() => this.closeMenu()}>
            <svg id="v7-boutique-coworking" data-name="v7-voutique-coworking" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 335.02 189.52">
              <defs>
              </defs>
              <title>v7-coworking</title>
              <path className="cls-1"
                    d="M73.2,188.91l.1-.35h5.55a10.28,10.28,0,0,1,2.3.24,5.64,5.64,0,0,1,1.8.71,3.56,3.56,0,0,1,1.18,1.2,3.33,3.33,0,0,1,.09,3.14,3.94,3.94,0,0,1-.89,1.13,5.4,5.4,0,0,1-1.22.81,9.52,9.52,0,0,1-1.33.51,9,9,0,0,1-1.23.29,7.77,7.77,0,0,1-.92.08l0,.05c.21.05.55.16,1,.32a6.43,6.43,0,0,1,1.39.73A4.62,4.62,0,0,1,82.21,199a3.31,3.31,0,0,1,.53,1.91A3.66,3.66,0,0,1,82,203.2a5.84,5.84,0,0,1-1.89,1.65,9.34,9.34,0,0,1-2.64,1,13.29,13.29,0,0,1-2.92.34c-.61,0-1.2,0-1.79,0s-1.18,0-1.81,0H67.39l.1-.34H70l6.08-16.86Zm.13,16.92c.36,0,.72,0,1.08,0a6.1,6.1,0,0,0,2.75-.58,6.22,6.22,0,0,0,1.9-1.45,5.66,5.66,0,0,0,1.11-1.91,6.25,6.25,0,0,0,.35-2,3.88,3.88,0,0,0-.14-1.08,2.84,2.84,0,0,0-.39-.8,3.09,3.09,0,0,0-.5-.57,2.36,2.36,0,0,0-.54-.35,3,3,0,0,0-1-.31,11.13,11.13,0,0,0-1.27-.06H75.42l-3.18,8.94Zm4.53-9.38a4.75,4.75,0,0,0,1.76-.32,4,4,0,0,0,1.4-.92,4.25,4.25,0,0,0,.91-1.5,5.89,5.89,0,0,0,.32-2,2.75,2.75,0,0,0-.77-2,2.87,2.87,0,0,0-2.16-.78h-1l-2.71,7.54Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M86.14,199.47a7.66,7.66,0,0,1,1.57-2.23,7.56,7.56,0,0,1,2.1-1.48,5.31,5.31,0,0,1,2.22-.54,3.47,3.47,0,0,1,1.68.39,3.86,3.86,0,0,1,1.18,1,4.37,4.37,0,0,1,.69,1.36,4.88,4.88,0,0,1,.22,1.43,6.13,6.13,0,0,1-.61,2.7,8.43,8.43,0,0,1-1.56,2.23,7.24,7.24,0,0,1-2.08,1.51,5,5,0,0,1-2.18.56,3.57,3.57,0,0,1-1.59-.35,3.9,3.9,0,0,1-1.21-.91,4.13,4.13,0,0,1-.77-1.32,4.66,4.66,0,0,1-.27-1.59A6.37,6.37,0,0,1,86.14,199.47Zm1.62,6a2,2,0,0,0,1.54.61,2.52,2.52,0,0,0,1.43-.45,4.73,4.73,0,0,0,1.2-1.17,8.82,8.82,0,0,0,1-1.61,16.39,16.39,0,0,0,.7-1.78,14.21,14.21,0,0,0,.43-1.67,7.19,7.19,0,0,0,.15-1.28,3.11,3.11,0,0,0-.51-1.88,2,2,0,0,0-1.76-.69,2.44,2.44,0,0,0-1.36.42,5.24,5.24,0,0,0-1.17,1.1,8.55,8.55,0,0,0-.95,1.54,12.64,12.64,0,0,0-.7,1.76,13.5,13.5,0,0,0-.43,1.75,8.81,8.81,0,0,0-.15,1.49A2.5,2.5,0,0,0,87.76,205.48Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M102.48,195.54l-2.83,8.13a8.91,8.91,0,0,0-.3.93,3.3,3.3,0,0,0-.1.6,1.06,1.06,0,0,0,.19.62.7.7,0,0,0,.63.27,2.68,2.68,0,0,0,1.44-.51,8,8,0,0,0,1.51-1.29,11.93,11.93,0,0,0,1.36-1.76,10,10,0,0,0,1-1.94l1.75-5.05h1.73l-2.91,8.35-.25.75a2.47,2.47,0,0,0-.12.73.8.8,0,0,0,.17.51.64.64,0,0,0,.52.21,1.37,1.37,0,0,0,.8-.27,4.57,4.57,0,0,0,.69-.63,5.86,5.86,0,0,0,.53-.73,6.5,6.5,0,0,0,.32-.59l.29.12-.3.61a4.08,4.08,0,0,1-.58.81,3.61,3.61,0,0,1-.91.7,2.64,2.64,0,0,1-1.29.3,2.17,2.17,0,0,1-1.29-.34A1.26,1.26,0,0,1,104,205a3,3,0,0,1,.1-.8,6.78,6.78,0,0,1,.29-.87l-.05-.05c-.23.29-.5.63-.82,1a10.11,10.11,0,0,1-1,1,6.19,6.19,0,0,1-1.18.81,2.65,2.65,0,0,1-1.29.34,2.61,2.61,0,0,1-1.68-.5,1.7,1.7,0,0,1-.61-1.43,2.65,2.65,0,0,1,.17-.87c.11-.34.21-.64.29-.9l2.42-6.83H98.42l.09-.34Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M116.21,193.12l-.89,2.42H118l-.1.34h-2.69l-2.81,7.84-.24.76a2.47,2.47,0,0,0-.13.79.94.94,0,0,0,.19.6.76.76,0,0,0,.6.22,1.45,1.45,0,0,0,.84-.27,4.78,4.78,0,0,0,.72-.63,5.08,5.08,0,0,0,.54-.73,6.5,6.5,0,0,0,.32-.59l.29.12c-.06.13-.17.33-.32.61a3.77,3.77,0,0,1-.59.81,3.33,3.33,0,0,1-.92.7,2.74,2.74,0,0,1-1.32.3A2,2,0,0,1,111,206a1.47,1.47,0,0,1-.46-1.1,4.17,4.17,0,0,1,.18-1.12c.12-.42.25-.8.38-1.14l2.42-6.71h-2.22l.1-.34h2.22l.88-2.42Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M118.6,195.88l.1-.34h3.92l-2.91,8.35-.25.75a2.47,2.47,0,0,0-.12.73.8.8,0,0,0,.17.51.64.64,0,0,0,.52.21,1.31,1.31,0,0,0,.77-.27,4.71,4.71,0,0,0,.71-.63,5.08,5.08,0,0,0,.54-.73,6.5,6.5,0,0,0,.32-.59l.3.12-.31.61a4.08,4.08,0,0,1-.58.81,3.61,3.61,0,0,1-.91.7,2.64,2.64,0,0,1-1.29.3,2.17,2.17,0,0,1-1.29-.34,1.26,1.26,0,0,1-.48-1.12A3.26,3.26,0,0,1,118,204c.1-.34.2-.65.29-.93l2.54-7.22Zm4.05-7a1.12,1.12,0,0,1,.83-.34,1.16,1.16,0,0,1,1.16,1.16,1.14,1.14,0,0,1-1.16,1.16,1.15,1.15,0,0,1-.83-.33,1.13,1.13,0,0,1-.33-.83A1.11,1.11,0,0,1,122.65,188.9Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M131.39,203.75c-.16.21-.38.47-.65.77a6.73,6.73,0,0,1-1,.88,5.93,5.93,0,0,1-1.2.71,3.28,3.28,0,0,1-1.39.3,3.16,3.16,0,0,1-1-.18,2.56,2.56,0,0,1-1.58-1.43,2.74,2.74,0,0,1-.26-1.25,5.56,5.56,0,0,1,.38-2,9,9,0,0,1,1-1.94,11.2,11.2,0,0,1,1.45-1.72,12.43,12.43,0,0,1,1.69-1.39,8.45,8.45,0,0,1,1.7-.93,4.23,4.23,0,0,1,1.53-.33,1.89,1.89,0,0,1,.83.17,1.75,1.75,0,0,1,.53.43,1.87,1.87,0,0,1,.29.56,1.94,1.94,0,0,1,.12.56h.05l.47-1.4h1.73L130,212.64h2l-.1.35H126l.1-.35h2.16l3.21-8.85Zm2.08-6a2.79,2.79,0,0,0,0-.47,2,2,0,0,0-.38-1.28,1.3,1.3,0,0,0-1-.47,2.7,2.7,0,0,0-1.48.48,7.17,7.17,0,0,0-1.42,1.27,12.36,12.36,0,0,0-1.24,1.77,17.36,17.36,0,0,0-1,2,11.89,11.89,0,0,0-.66,1.89,6.11,6.11,0,0,0-.24,1.52,2,2,0,0,0,.32,1.13,1.16,1.16,0,0,0,1,.5,2.72,2.72,0,0,0,1.43-.47,8.43,8.43,0,0,0,1.38-1.1,10.8,10.8,0,0,0,1.11-1.28,5,5,0,0,0,.61-1.05l1.38-3.84A2.24,2.24,0,0,0,133.47,197.78Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M142.65,195.54l-2.83,8.13a8.91,8.91,0,0,0-.3.93,3.3,3.3,0,0,0-.1.6,1.06,1.06,0,0,0,.19.62.7.7,0,0,0,.63.27,2.68,2.68,0,0,0,1.44-.51,8,8,0,0,0,1.51-1.29,11.93,11.93,0,0,0,1.36-1.76,10,10,0,0,0,1-1.94l1.75-5.05H149l-2.91,8.35c-.08.25-.17.5-.25.75a2.47,2.47,0,0,0-.12.73.8.8,0,0,0,.17.51.64.64,0,0,0,.52.21,1.37,1.37,0,0,0,.8-.27,4.57,4.57,0,0,0,.69-.63,5.86,5.86,0,0,0,.53-.73,6.5,6.5,0,0,0,.32-.59l.29.12-.3.61a4.08,4.08,0,0,1-.58.81,3.61,3.61,0,0,1-.91.7,2.64,2.64,0,0,1-1.29.3,2.17,2.17,0,0,1-1.29-.34,1.26,1.26,0,0,1-.48-1.12,3,3,0,0,1,.1-.8,6.78,6.78,0,0,1,.29-.87l0-.05c-.23.29-.5.63-.82,1a10.11,10.11,0,0,1-1,1,6.19,6.19,0,0,1-1.18.81,2.65,2.65,0,0,1-1.29.34,2.61,2.61,0,0,1-1.68-.5,1.7,1.7,0,0,1-.61-1.43,2.65,2.65,0,0,1,.17-.87c.11-.34.21-.64.29-.9l2.42-6.83h-2.19l.09-.34Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M158.13,204.32a4.77,4.77,0,0,1-.81.92,5.77,5.77,0,0,1-1.27.81,4.22,4.22,0,0,1-1.82.36,4.12,4.12,0,0,1-1.78-.35,3.26,3.26,0,0,1-1.18-.89,3.35,3.35,0,0,1-.67-1.19,4.17,4.17,0,0,1-.21-1.27,6.15,6.15,0,0,1,.6-2.55,10.09,10.09,0,0,1,1.58-2.42,9.09,9.09,0,0,1,2.21-1.81,5,5,0,0,1,2.51-.71,4.17,4.17,0,0,1,1,.11,3.08,3.08,0,0,1,.88.33,1.87,1.87,0,0,1,.64.57,1.37,1.37,0,0,1,.25.84,2,2,0,0,1-.36,1.17,3.17,3.17,0,0,1-.92.86,6,6,0,0,1-1.25.6,9.15,9.15,0,0,1-1.31.39c-.43.09-.82.15-1.17.19s-.62.06-.78.06-.55,0-.81,0-.5,0-.69-.07a15.33,15.33,0,0,0-.46,1.56,7.3,7.3,0,0,0-.18,1.64,2.59,2.59,0,0,0,.69,2,2.42,2.42,0,0,0,1.75.66,3.12,3.12,0,0,0,1.39-.31,5.1,5.1,0,0,0,1.06-.73,5.34,5.34,0,0,0,.76-.85c.21-.29.37-.51.51-.68l.29.18A6.49,6.49,0,0,0,158.13,204.32Zm.1-8.41a1.25,1.25,0,0,0-1-.35,2.69,2.69,0,0,0-1.47.45,5.65,5.65,0,0,0-1.26,1.09,8.53,8.53,0,0,0-1,1.41,8.78,8.78,0,0,0-.64,1.39,7,7,0,0,0,1.26.1,5.08,5.08,0,0,0,1.67-.27,4.94,4.94,0,0,0,1.39-.72,3.5,3.5,0,0,0,1-1,2.45,2.45,0,0,0,.35-1.23A1.28,1.28,0,0,0,158.23,195.91Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M182,193.32c0-.16.06-.4.1-.71s0-.64,0-1a2.9,2.9,0,0,0-.3-1.36,2.56,2.56,0,0,0-.8-.95,3.69,3.69,0,0,0-1.2-.56,5.8,5.8,0,0,0-1.47-.18,4.14,4.14,0,0,0-2.39.74,8.75,8.75,0,0,0-2,1.92,15.88,15.88,0,0,0-1.65,2.67,27.07,27.07,0,0,0-1.23,3,22.13,22.13,0,0,0-.77,2.88,13.28,13.28,0,0,0-.25,2.37,3.8,3.8,0,0,0,1.08,3,4.45,4.45,0,0,0,3.08,1,4.71,4.71,0,0,0,2-.39,6.86,6.86,0,0,0,1.53-1,6.2,6.2,0,0,0,1.12-1.24,11.2,11.2,0,0,0,.75-1.2l.32.17c-.09.2-.28.51-.54.95a6.9,6.9,0,0,1-1.09,1.32,7.21,7.21,0,0,1-1.72,1.17,5.37,5.37,0,0,1-2.39.5,6,6,0,0,1-2.82-.6,5.28,5.28,0,0,1-1.85-1.58,6.39,6.39,0,0,1-1-2.23,11.13,11.13,0,0,1-.31-2.59,9.23,9.23,0,0,1,.46-2.91,11.75,11.75,0,0,1,1.23-2.64,12.87,12.87,0,0,1,1.81-2.28,13.29,13.29,0,0,1,2.18-1.78,11.5,11.5,0,0,1,2.33-1.16,6.8,6.8,0,0,1,2.27-.42,6.1,6.1,0,0,1,1.43.15,9.75,9.75,0,0,1,1.1.33l.87.34a2.14,2.14,0,0,0,.76.15,1,1,0,0,0,.65-.21,1.65,1.65,0,0,0,.39-.51l.37.07-1.7,4.76Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M183.34,199.47a7.64,7.64,0,0,1,3.67-3.71,5.24,5.24,0,0,1,2.22-.54,3.47,3.47,0,0,1,1.68.39,3.86,3.86,0,0,1,1.18,1,4.37,4.37,0,0,1,.69,1.36,4.88,4.88,0,0,1,.22,1.43,6.14,6.14,0,0,1-.62,2.7,8.39,8.39,0,0,1-1.55,2.23,7.38,7.38,0,0,1-2.08,1.51,5,5,0,0,1-2.18.56,3.57,3.57,0,0,1-1.59-.35,3.9,3.9,0,0,1-1.21-.91,4,4,0,0,1-.78-1.32,4.66,4.66,0,0,1-.27-1.59A6.38,6.38,0,0,1,183.34,199.47Zm1.61,6a2.08,2.08,0,0,0,1.54.61,2.5,2.5,0,0,0,1.43-.45,4.61,4.61,0,0,0,1.21-1.17,9.39,9.39,0,0,0,1-1.61,13.12,13.12,0,0,0,.7-1.78,14.36,14.36,0,0,0,.44-1.67,8.05,8.05,0,0,0,.14-1.28,3.11,3.11,0,0,0-.5-1.88,2.05,2.05,0,0,0-1.76-.69,2.44,2.44,0,0,0-1.36.42,4.84,4.84,0,0,0-1.17,1.1,8.55,8.55,0,0,0-1,1.54,12.64,12.64,0,0,0-.7,1.76,13.5,13.5,0,0,0-.43,1.75,8.81,8.81,0,0,0-.15,1.49A2.54,2.54,0,0,0,185,205.48Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M205.67,195.8a5.76,5.76,0,0,0-1.27,1.83,3.19,3.19,0,0,0-.26,1.26,5.65,5.65,0,0,0,.25,1.73c.16.52.36,1.07.59,1.65.14.39.26.75.35,1.07a4.56,4.56,0,0,1,.17.9l1.3-1.06a16.56,16.56,0,0,0,1.45-1.33,8.19,8.19,0,0,0,1.18-1.54,3.3,3.3,0,0,0,.48-1.67,2.68,2.68,0,0,0-.13-.92,3.06,3.06,0,0,0-.28-.63,5.36,5.36,0,0,1-.28-.52,1.13,1.13,0,0,1-.13-.56.64.64,0,0,1,.34-.61,1.63,1.63,0,0,1,.8-.18q1.2,0,1.2,1.8a4.38,4.38,0,0,1-.29,1.59,7,7,0,0,1-.77,1.46,9.37,9.37,0,0,1-1.07,1.32c-.4.42-.8.8-1.19,1.15l-1.26,1.08a9.1,9.1,0,0,1-1,.79,5.49,5.49,0,0,0-.76.64c-.26.26-.49.51-.68.74a4.15,4.15,0,0,0-.43.62l-.32-.18a1.7,1.7,0,0,0,.3-1.1,2.57,2.57,0,0,0-.1-.73l-.22-.65-.52-1.43c-.1-.33-.18-.6-.25-.79s-.12-.39-.17-.57c-.23.23-.48.46-.74.7s-.55.52-.86.83l-1.26,1.08a10.25,10.25,0,0,1-1,.79,5.68,5.68,0,0,0-.77.64,6.27,6.27,0,0,0-1.11,1.41l-.32-.18a1.8,1.8,0,0,0,.3-1.15,2.57,2.57,0,0,0-.1-.73l-.22-.65-.52-1.43c-.15-.38-.28-.77-.41-1.16a3.65,3.65,0,0,1,.62-3.41,12.32,12.32,0,0,1,2.08-2.26l.52-.39.22.24-.48.48a9.49,9.49,0,0,0-.67.79,6.42,6.42,0,0,0-.59,1,3,3,0,0,0-.25,1.24,5.94,5.94,0,0,0,.23,1.73c.15.52.35,1.07.58,1.65.15.39.27.75.36,1.07a4.5,4.5,0,0,1,.16.9l1.3-1.06a15.24,15.24,0,0,0,1.46-1.33,8.13,8.13,0,0,0,1.17-1.54,3.3,3.3,0,0,0,.48-1.67,2.68,2.68,0,0,0-.13-.92,3.06,3.06,0,0,0-.28-.63,5.36,5.36,0,0,1-.28-.52,1.13,1.13,0,0,1-.13-.56.61.61,0,0,1,.34-.57,1.78,1.78,0,0,1,.8-.17,1.1,1.1,0,0,1,.82.45,1.36,1.36,0,0,1,.31.83,10.8,10.8,0,0,1,.83-.83c.32-.28.57-.49.75-.62l.22.24A6.62,6.62,0,0,1,205.67,195.8Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M213.46,199.47a7.82,7.82,0,0,1,1.56-2.23,7.46,7.46,0,0,1,2.11-1.48,5.23,5.23,0,0,1,2.21-.54,3.45,3.45,0,0,1,1.68.39,3.75,3.75,0,0,1,1.18,1,4,4,0,0,1,.69,1.36,4.9,4.9,0,0,1,.23,1.43,6.14,6.14,0,0,1-.62,2.7,8.63,8.63,0,0,1-1.55,2.23,7.42,7.42,0,0,1-2.09,1.51,5,5,0,0,1-2.18.56,3.57,3.57,0,0,1-1.59-.35,3.85,3.85,0,0,1-1.2-.91,4,4,0,0,1-.78-1.32,4.66,4.66,0,0,1-.27-1.59A6.24,6.24,0,0,1,213.46,199.47Zm1.61,6a2.06,2.06,0,0,0,1.54.61,2.5,2.5,0,0,0,1.43-.45,4.94,4.94,0,0,0,1.21-1.17,9.39,9.39,0,0,0,1-1.61,14.57,14.57,0,0,0,.7-1.78,14.21,14.21,0,0,0,.43-1.67,7.19,7.19,0,0,0,.15-1.28,3.11,3.11,0,0,0-.51-1.88,2,2,0,0,0-1.76-.69,2.41,2.41,0,0,0-1.35.42,4.84,4.84,0,0,0-1.17,1.1,8,8,0,0,0-.95,1.54,12.7,12.7,0,0,0-.71,1.76,15.35,15.35,0,0,0-.43,1.75,8.69,8.69,0,0,0-.14,1.49A2.54,2.54,0,0,0,215.07,205.48Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M227.9,197.21l.39-1.33h-2.14l.1-.34H230c-.08.34-.2.78-.36,1.3s-.32,1-.5,1.53l0,0,.61-.88a8.73,8.73,0,0,1,.84-1,5.15,5.15,0,0,1,1-.82,2.33,2.33,0,0,1,1.2-.33,1.8,1.8,0,0,1,1.4.52,1.48,1.48,0,0,1,.45,1.11,1.39,1.39,0,0,1-.13.65,1,1,0,0,1-.35.39,1.09,1.09,0,0,1-.43.19,2.18,2.18,0,0,1-.42.05.89.89,0,0,1-.56-.17.63.63,0,0,1-.23-.52.67.67,0,0,1,.11-.41l.24-.26a2,2,0,0,0,.23-.27.6.6,0,0,0,.11-.39.47.47,0,0,0-.19-.4.89.89,0,0,0-.5-.14,1.86,1.86,0,0,0-1.08.48,7.48,7.48,0,0,0-1.22,1.23,12.87,12.87,0,0,0-2,3.63l-1.78,5h-1.72l2.66-7.59C227.63,198.09,227.77,197.66,227.9,197.21Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M239,187.73l.1-.35h3.94l-4.24,11.88h.52a2.31,2.31,0,0,0,1.6-.67,9,9,0,0,0,1.36-1.52c.92-1.24,1.81-1.85,2.69-1.85a1.31,1.31,0,0,1,.9.31,1.33,1.33,0,0,1,.35,1,1.26,1.26,0,0,1-.29.88,1,1,0,0,1-.74.31c-.59,0-.89-.22-.89-.67a.75.75,0,0,1,.1-.45.72.72,0,0,0,.1-.39c0-.19-.13-.29-.4-.29a1,1,0,0,0-.63.33c-.22.22-.48.52-.8.9l-.61.74a6.21,6.21,0,0,1-.93,1,2.27,2.27,0,0,1-.75.48v.08l.58.11a1.55,1.55,0,0,1,.59.26,2,2,0,0,1,.53.56,2.74,2.74,0,0,1,.37,1l.64,3.28a5,5,0,0,0,.27.85.6.6,0,0,0,.57.38,1,1,0,0,0,.65-.27,3.48,3.48,0,0,0,.56-.64,8.09,8.09,0,0,0,.42-.74q.17-.37.24-.57l.35.1c-.12.26-.25.55-.41.85a3.94,3.94,0,0,1-.58.84,3.18,3.18,0,0,1-.81.64,2.28,2.28,0,0,1-1.11.26,1.77,1.77,0,0,1-1.13-.34,2.36,2.36,0,0,1-.69-1.41l-.67-3.08c0-.27-.1-.52-.16-.75a2.24,2.24,0,0,0-.25-.63,1.11,1.11,0,0,0-.43-.43,1.36,1.36,0,0,0-.71-.16h-.54l-2.32,6.5h-1.7l6.56-18.38Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M248.65,195.88l.1-.34h3.91l-2.9,8.35c-.09.25-.17.5-.25.75a2.47,2.47,0,0,0-.12.73.75.75,0,0,0,.17.51.63.63,0,0,0,.52.21,1.31,1.31,0,0,0,.77-.27,4.71,4.71,0,0,0,.71-.63,5.08,5.08,0,0,0,.54-.73,6.5,6.5,0,0,0,.32-.59l.29.12c-.06.13-.17.33-.3.61a4.08,4.08,0,0,1-.58.81,3.61,3.61,0,0,1-.91.7,2.64,2.64,0,0,1-1.29.3,2.17,2.17,0,0,1-1.29-.34,1.26,1.26,0,0,1-.48-1.12A3.26,3.26,0,0,1,248,204c.1-.34.19-.65.29-.93l2.54-7.22Zm4-7a1.1,1.1,0,0,1,.83-.34,1.08,1.08,0,0,1,.82.34,1.12,1.12,0,0,1,.34.82,1.14,1.14,0,0,1-.34.83,1.11,1.11,0,0,1-.82.33,1.13,1.13,0,0,1-1.16-1.16A1.11,1.11,0,0,1,252.7,188.9Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M255.6,195.88l.1-.34h3.89l-1,3h.05c1.59-2.12,3.1-3.18,4.51-3.18a2.33,2.33,0,0,1,1.64.56,1.78,1.78,0,0,1,.6,1.36,2.62,2.62,0,0,1-.13.83c-.09.27-.21.59-.34,1l-1.6,4.56c-.1.28-.19.56-.27.83a2.82,2.82,0,0,0-.12.8,1.19,1.19,0,0,0,.12.54.53.53,0,0,0,.52.25,1.49,1.49,0,0,0,.81-.25,3.43,3.43,0,0,0,.68-.59,4.68,4.68,0,0,0,.53-.73,6,6,0,0,0,.34-.65l.27.12c-.08.17-.19.38-.34.65a4.2,4.2,0,0,1-.58.81,3.47,3.47,0,0,1-.87.67,2.55,2.55,0,0,1-1.24.29,2.44,2.44,0,0,1-1.33-.35,1.24,1.24,0,0,1-.54-1.13,2.63,2.63,0,0,1,.09-.67,7.14,7.14,0,0,1,.21-.74l2.07-5.89a3.21,3.21,0,0,0,.19-1,1.05,1.05,0,0,0-.21-.62.85.85,0,0,0-.75-.29,2.58,2.58,0,0,0-1.25.4,6.67,6.67,0,0,0-1.43,1.11,10.27,10.27,0,0,0-1.35,1.65,9.42,9.42,0,0,0-1,2.06L256,206.11h-1.7l3.55-10.23Z"
                    transform="translate(-6.49 -23.74)"/>
              <path className="cls-1"
                    d="M275.79,205.87a2.26,2.26,0,0,1,.93,2,4.3,4.3,0,0,1-.42,1.77,5.75,5.75,0,0,1-1.21,1.74,6.12,6.12,0,0,1-1.93,1.32,6.27,6.27,0,0,1-2.63.52,6.35,6.35,0,0,1-1.82-.26,5.89,5.89,0,0,1-1.52-.68,3.55,3.55,0,0,1-1-1,2.09,2.09,0,0,1-.37-1.16,2.34,2.34,0,0,1,.28-1.11,5,5,0,0,1,.68-.95,5.19,5.19,0,0,1,.83-.74q.44-.31.72-.48l.69-.37-.55-.17a2.35,2.35,0,0,1-.59-.3,1.46,1.46,0,0,1-.47-.54,2,2,0,0,1-.18-.91,2.47,2.47,0,0,1,.39-1.37,3.52,3.52,0,0,1,1.33-1.1l.91-.49a3.83,3.83,0,0,1-.53-.8,2.57,2.57,0,0,1-.21-1.12,3.38,3.38,0,0,1,.47-1.7,5.37,5.37,0,0,1,1.21-1.44,5.82,5.82,0,0,1,1.63-1,4.37,4.37,0,0,1,1.72-.37,3.75,3.75,0,0,1,1.12.15,3,3,0,0,1,.85.38,2.88,2.88,0,0,1,.62.5,3.9,3.9,0,0,1,.39.52,6.26,6.26,0,0,1,.72-.87,1.56,1.56,0,0,1,1.18-.44,1.58,1.58,0,0,1,1.12.45,1.41,1.41,0,0,1,.48,1.08,1.09,1.09,0,0,1-.24.73,1,1,0,0,1-.82.28.93.93,0,0,1-.58-.17.53.53,0,0,1-.23-.44.68.68,0,0,1,.07-.35,1.24,1.24,0,0,1,.18-.22,1.37,1.37,0,0,0,.17-.23.82.82,0,0,0,.07-.39.41.41,0,0,0-.12-.27.48.48,0,0,0-.35-.12,1.09,1.09,0,0,0-.77.37,3.16,3.16,0,0,0-.66.94,1.66,1.66,0,0,1,.26.58,2.26,2.26,0,0,1,.11.7,3,3,0,0,1-.45,1.55,5.69,5.69,0,0,1-1.18,1.38,6.6,6.6,0,0,1-1.59,1,4.4,4.4,0,0,1-1.68.37,4.17,4.17,0,0,1-1.74-.29,10.14,10.14,0,0,1-.92-.48l-.52.25a3.86,3.86,0,0,0-1.2.82,1.39,1.39,0,0,0-.4.9.85.85,0,0,0,.53.8,4.65,4.65,0,0,0,1.71.34l3.16.14A4.55,4.55,0,0,1,275.79,205.87Zm-8,2.5a3.75,3.75,0,0,0-.34,1.71,2.93,2.93,0,0,0,.26,1.32,2.47,2.47,0,0,0,.69.87,2.6,2.6,0,0,0,1,.5,4.71,4.71,0,0,0,1.12.14,5.82,5.82,0,0,0,2-.35,6.49,6.49,0,0,0,1.68-.93,4.51,4.51,0,0,0,1.14-1.3,3.1,3.1,0,0,0,.42-1.53,2,2,0,0,0-.13-.75,1.59,1.59,0,0,0-.46-.64,2.41,2.41,0,0,0-.86-.47,4.21,4.21,0,0,0-1.33-.21l-3.48-.13-.69.55A3.75,3.75,0,0,0,267.77,208.37Zm3.58-6.46a2.16,2.16,0,0,0,1.45.43,2.19,2.19,0,0,0,1.42-.49,4.09,4.09,0,0,0,1-1.22,5.64,5.64,0,0,0,.58-1.58,7,7,0,0,0,.19-1.56,1.78,1.78,0,0,0-.56-1.51,2.18,2.18,0,0,0-1.36-.42,2,2,0,0,0-1.36.51,4.84,4.84,0,0,0-1,1.22,6.27,6.27,0,0,0-.64,1.53,5.44,5.44,0,0,0-.22,1.45A2,2,0,0,0,271.35,201.91Z"
                    transform="translate(-6.49 -23.74)"/>
              <polygon className="cls-1"
                       points="33.31 109.29 19.14 138.71 4.97 109.29 0 109.29 17.71 146 20.57 146 38.34 109.29 33.31 109.29 33.31 109.29"/>
              <polygon className="cls-1"
                       points="49.58 109.08 54.22 109.08 54.22 146.14 49.58 146.14 49.58 109.08 49.58 109.08"/>
              <polygon className="cls-1"
                       points="71.38 109.29 75.94 109.29 75.94 141.78 99.92 141.78 99.92 146 71.38 146 71.38 109.29 71.38 109.29"/>
              <polygon className="cls-1"
                       points="111.56 109.29 116.19 109.29 116.19 123.8 137.85 123.8 137.85 109.29 142.41 109.29 142.41 146 137.85 146 137.85 128.02 116.19 128.02 116.19 146 111.56 146 111.56 109.29 111.56 109.29"/>
              <polygon className="cls-1"
                       points="159.65 109.29 188.52 109.29 188.52 113.51 164.21 113.51 164.21 124.27 178.92 124.27 178.92 128.5 164.21 128.5 164.21 141.78 190.02 141.78 190.02 146 159.65 146 159.65 109.29 159.65 109.29"/>
              <polygon className="cls-1"
                       points="202.96 109.29 207.52 109.29 207.52 141.78 231.5 141.78 231.5 146 202.96 146 202.96 109.29 202.96 109.29"/>
              <polygon className="cls-1"
                       points="242.94 109.29 247.16 109.29 262.01 131.77 276.93 109.29 281.08 109.29 281.08 146 276.59 146 276.59 117.33 262.01 139.05 247.43 117.33 247.43 146 242.94 146 242.94 109.29 242.94 109.29"/>
              <polygon className="cls-1"
                       points="326.44 115.35 299.54 115.35 299.54 111.06 335.02 111.06 310.36 146 304.99 146 326.44 115.35 326.44 115.35"/>
              <polygon className="cls-1" points="1.28 109.29 0 109.29 1.28 111.94 1.28 109.29 1.28 109.29"/>
              <polygon className="cls-1"
                       points="335.02 111.06 333.74 111.06 333.74 112.87 335.02 111.06 335.02 111.06"/>
              <polygon className="cls-1"
                       points="205.53 0 200.76 0 167.51 68.91 134.25 0 129.49 0 167.5 78.75 167.52 78.75 205.53 0 205.53 0"/>
              <polygon className="cls-1"
                       points="191.09 0 167.55 48.79 143.92 0 139.16 0 167.51 58.73 195.85 0 191.09 0 191.09 0"/>
              <polygon className="cls-1"
                       points="150.91 3.9 179.93 3.9 165.28 34.24 167.66 39.17 186.56 0 149.13 0 150.91 3.9 150.91 3.9"/>
            </svg>

          </Img>
          </ImgDiv>

          <ToggleDiv>  <Toggler/></ToggleDiv>


            <BorderTopBottom><StyledLink to={'/philosophie'}> <A onClick={() => this.closeMenu()}>  Philosophie</A></StyledLink></BorderTopBottom>
          <BorderBottom>  <StyledLink to={'/services'}> <A onClick={() => this.closeMenu()}>Services</A> </StyledLink></BorderBottom>
            <BorderBottom>  <StyledLink to={'/lage'}> <A  onClick={() => this.closeMenu()}>Lage</A></StyledLink></BorderBottom>
              <BorderBottom>  <StyledLink_2 to={'/buchung'}> <A  onClick={() => this.closeMenu()}>Buchung</A> </StyledLink_2></BorderBottom>
          <BorderBottom><StyledLink_3> <A onClick={() => this.setTab(4)} style={{borderBottom: this.state.currentTab===5 ?'2px solid rgba(68,68,68,.4)':'2px solid rgba(255,255,255,0.0)' }} href="https://www.vilhelm7.de/">Residences</A> </StyledLink_3>
         </BorderBottom>
          <BorderBottom>  <StyledLink_2 to={'/kontakt'}> <A  onClick={() => this.closeMenu()}>Kontakt</A> </StyledLink_2></BorderBottom>


          <BorderBottom><StyledLink to={'/faq'}> <A onClick={() => this.closeMenu()}>  FAQ</A></StyledLink></BorderBottom>
          <BorderBottom>  <StyledLink to={'/impressum'}> <A onClick={() => this.closeMenu()}>Impressum</A> </StyledLink></BorderBottom>
          <BorderBottom>  <StyledLink_3 href={'https://vilhelm7.de/datenschutz'}> <A  onClick={() => this.closeMenu()}>Datenschutz</A></StyledLink_3></BorderBottom>
          <BorderBottom>  <StyledLink_2 to={'/agb'}> <A  onClick={() => this.closeMenu()}>AGB</A> </StyledLink_2></BorderBottom>





        </StyledMenu>
      </HeadroomDiv>
    )
  }
}
